"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Content_1 = __importDefault(require("./styledComponents/Content"));

var ToggleWrapper_1 = __importDefault(require("./styledComponents/ToggleWrapper"));

var Button_1 = __importDefault(require("../Button"));

var Tooltip_1 = __importDefault(require("../Tooltip"));

var DEFAULT_TOGGLE_BUTTONS = {
  expand: {
    text: 'Read more'
  },
  collapse: {
    text: 'Read less'
  }
};

var Text_meta_1 = require("./Text.meta");

var Text =
/** @class */
function (_super) {
  __extends(Text, _super);

  function Text(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Text_meta_1.TEXT_CATEGORY_KEY;
    _this.componentKey = Text_meta_1.TEXT_COMPONENT_KEY;

    _this.handleToggle = function (event, buttonProps) {
      var previousToggleState = _this.state.toggleState || 'expanded';
      var newToggleState = previousToggleState === 'expanded' ? 'collapsed' : 'expanded';
      var onClick = buttonProps.onClick;

      if (onClick) {
        onClick(event);
      }

      _this.setState({
        toggleState: newToggleState
      });
    };

    _this.renderContent = function (allowToggle, textOverflowResponse) {
      var _a = _this.props,
          hasHtmlContent = _a.hasHtmlContent,
          tooltip = _a.tooltip;
      var _b = _this.state.toggleState,
          toggleState = _b === void 0 ? 'expanded' : _b;
      var workingToggleState = allowToggle ? toggleState : 'expanded';

      var text = _this.content(textOverflowResponse);

      return react_1.default.createElement(Content_1.default, {
        toggleState: workingToggleState
      }, tooltip && tooltip.placement === 'left' && _this.getTooltip(tooltip), hasHtmlContent && react_1.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: text
        }
      }), !hasHtmlContent && text, tooltip && (!tooltip.placement || tooltip.placement === 'right') && _this.getTooltip(tooltip));
    };

    _this.state = {
      toggleState: props.toggleState || 'expanded',
      initialToggleState: props.toggleState
    };
    return _this;
  }

  Text.getDerivedStfvateFromProps = function (nextProps, previousState) {
    if (nextProps.toggleState && nextProps.toggleState !== previousState.initialToggleState) {
      return {
        toggleState: nextProps.toggleState,
        initialToggleState: nextProps.toggleState
      };
    }

    return null;
  };

  Text.prototype.allowToggle = function (textOverflowResponse) {
    var collapse = this.props.collapse;
    return !!(collapse && collapse.maxLength && collapse.maxLength > 0 && textOverflowResponse && textOverflowResponse.counter && textOverflowResponse.counter.current !== textOverflowResponse.counter.total);
  };

  Text.prototype.content = function (textOverflowResponse) {
    var _a = this.props,
        collapse = _a.collapse,
        value = _a.value;
    var _b = this.state.toggleState,
        toggleState = _b === void 0 ? 'expanded' : _b;
    var response = value;

    if (this.allowToggle(textOverflowResponse) && collapse && textOverflowResponse) {
      var maxLength = collapse.maxLength,
          suffix = collapse.suffix;

      if (toggleState === 'collapsed') {
        response = textOverflowResponse.content;
      }
    }

    return this.textOverflowHelper.stripAttributeFromElements(response, ['style', 'class']);
  };

  Text.prototype.getTooltip = function (tooltip) {
    var placement = tooltip.placement,
        tooltipProps = __rest(tooltip, ["placement"]);

    return tooltipProps && react_1.default.createElement(Tooltip_1.default, __assign({}, tooltipProps));
  };

  Object.defineProperty(Text.prototype, "toggleButton", {
    get: function get() {
      var _this = this;

      var _a = this.props.toggleButtons,
          toggleButtons = _a === void 0 ? DEFAULT_TOGGLE_BUTTONS : _a;
      var _b = this.state.toggleState,
          toggleState = _b === void 0 ? 'expanded' : _b;
      var toggleButtonsKey = toggleState === 'expanded' ? 'collapse' : 'expand';
      var buttonProps = toggleButtons[toggleButtonsKey];
      return react_1.default.createElement(Button_1.default, __assign({}, buttonProps, {
        onClick: function onClick(event) {
          return _this.handleToggle(event, buttonProps);
        }
      }));
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "textOverflowHelper", {
    get: function get() {
      var collapse = this.props.collapse;
      var length;
      var suffix;

      if (collapse) {
        length = collapse.maxLength;
        suffix = collapse.suffix;
      }

      var options = {
        length: length,
        suffix: suffix,
        mustStripStyle: true
      };
      return new ksys_app_template_1.helpers.TextOverflowHelper(options);
    },
    enumerable: true,
    configurable: true
  });

  Text.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        value = _a.value;
    var textOverflowResponse = this.textOverflowHelper.get(value || '');
    var allowToggle = this.allowToggle(textOverflowResponse);
    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, this.renderContent(allowToggle, textOverflowResponse), allowToggle && react_1.default.createElement(ToggleWrapper_1.default, null, this.toggleButton));
  };

  Text.defaultProps = {
    value: '',
    toggleButtons: DEFAULT_TOGGLE_BUTTONS
  };
  Text = __decorate([mobx_react_1.observer], Text);
  return Text;
}(shared_1.ComponentBase);

exports.Text = Text;
exports.default = shared_1.InjectedStyledComponent(Text, Text_meta_1.TEXT_CATEGORY_KEY, Text_meta_1.TEXT_COMPONENT_KEY);